import { produce } from 'immer'
import { ICompanyConfigInitialState } from 'interfaces/Iredux'
import { COMPANY_RADIUS_DEFAULTS } from 'actions/companyConfig'

const initialState: ICompanyConfigInitialState = {
  companyRadiusDefaults: null,
}

const companyConfigReducer = (state = initialState, action: any) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case COMPANY_RADIUS_DEFAULTS:
        draft.companyRadiusDefaults = action.data
        break
      default:
        break
    }
  })
}

export default companyConfigReducer
